export default __webpack_public_path__ + "static/FeatureThree-c88d45e307b072b00b9f5d23e0bdfb5f.webp";